module.exports = __webpack_public_path__ + "static/img/1.688157f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/HeavyCopper/1.png
// module id = S3KG
// module chunks = 1